import { useState, useEffect } from 'react'
import { fetchPrograms } from '../utils'
import { Program } from '../types'
export function useProgramsPerDay(
  callLeter: string,
  day: string,
  isInView: boolean
) {
  const [data, setData] = useState<Program[] | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    async function load() {
      setIsLoading(true)
      try {
        const channels = await fetchPrograms(callLeter, day)
        setData(channels)
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    if (!isInView) return
    load()
  }, [isInView, callLeter])

  return { data, isLoading, error }
}
